import React, {
  Fragment, useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const statusTypeMapping = {
  SALES_ORDER: ['DRAFT', 'CONFIRMED'],
  ANNUAL_MAINTENANCE_CONTRACT: ['DRAFT', 'CONFIRMED'],
  PACKING_SLIP: ['DRAFT', 'CONFIRMED'],
  CONSUMPTION_ORDER: ['CONFIRMED'],
  INVOICE: ['DRAFT', 'CONFIRMED'],
  DELIVERY_CHALLAN :['DRAFT', 'CONFIRMED'],
};

const statusColors = {
  LIGHT_BLUE: '#88B4F8',
  GOLD: '#dcaa06',
  GRAY: '#939393',
  GREEN: '#22C55E',
  BLUE: '#1c7be1',
  RED: '#ff0000',
  AZURE: '#2daef7',
  SILVER: '#b0b0b0',
  ROYAL_BLUE: '#3e77cc',
  ORANGE: '#f68d16',
  CYAN: '#06b5dc',
};

const FormCustomStatus = ({
  user, selectedStatus, entity, createCustomStatusLoading, updateCustomStatusLoading,
  createCustomStatus, updateCustomStatus, callback, possibleFromStatuses,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const [isFinal, setIsFinal] = useState(null);
  const [allowedFromStatus, setAllowedFromStatus] = useState([]);
  const [customStatus, setCustomStatus] = useState('');
  const [selectedColor, setSelectedColor] = useState('');

  useEffect(() => {
    if (selectedStatus) {
      setCustomStatus(selectedStatus?.status_name);
      setSelectedType(selectedStatus.type);
      setSelectedColor(selectedStatus?.color_code);
      setIsFinal(selectedStatus?.is_final ? 'YES' : 'NO');
      setAllowedFromStatus(selectedStatus?.from_status?.split(',')?.map((i) => Number(i)));
    }
  }, [selectedStatus]);

  function handleAddCM() {
    setFormSubmitted(true);
    if (customStatus && selectedType && selectedColor && isFinal) {
      if (selectedStatus) {
        const payload = {
          custom_status_id: selectedStatus?.custom_status_id,
          entity_name: entity,
          status_name: customStatus,
          org_id: user?.tenant_info?.org_id,
          type: selectedType,
          is_default: false,
          is_final: isFinal === 'YES',
          from_status: allowedFromStatus?.length ? allowedFromStatus?.join(',') : null,
          color_code: selectedColor,
        };
        updateCustomStatus(payload, () => { callback(); });
      } else {
        const payload = {
          entity_name: entity,
          status_name: customStatus,
          org_id: user?.tenant_info?.org_id,
          type: selectedType,
          is_default: false,
          is_final: isFinal === 'YES',
          from_status: allowedFromStatus?.length ? allowedFromStatus?.join(',') : null,
          color_code: selectedColor,
        };
        createCustomStatus(payload, () => { callback(); });
      }
    }
  }
  return (
    <div>
      {' '}
      <Fragment>
        <div className="ant-row new-custom-statue-form__wrapper">
          <div className="ant-col-md-24">
            <H3FormInput
              name="Status Name"
              type="text"
              containerClassName="orgInputContainer create__right-input"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => setCustomStatus(e.target.value?.toUpperCase())}
              disabled={createCustomStatusLoading || updateCustomStatusLoading}
              value={customStatus}
              label="Please enter a status name"
              maxlength="50"
              required
              showError={formSubmitted && !customStatus}
            />
          </div>
          {!selectedStatus && (
            <div className="ant-col-md-24">
              <div className="orgInputContainer">
                <label className="orgFormLabel">
                  {`Select ${entity?.replaceAll('_', ' ')?.toLowerCase()} Stage`}
                  <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
                </label>
                <PRZSelect
                  onChange={(e) => setSelectedType(e)}
                  value={selectedType}
                  showSearch
                  optionFilterProp="children"
                  options={statusTypeMapping[entity]?.map((i) => ({
                    label: i,
                    value: i,
                  }))}
                  showError={formSubmitted && !selectedType}
                  errorName="/ select a stage"
                  errorClassName="formError"
                />
              </div>
            </div>
          )}

          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Do you want to allow
                {' '}
                {entity?.replaceAll('_', ' ')?.toLowerCase()}
                {' '}
                to move to next stage from this status?
                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
              </label>
              <PRZSelect
                onChange={(e) => setIsFinal(e)}
                value={isFinal}
                showSearch
                optionFilterProp="children"
                showError={formSubmitted && !isFinal}
                errorName="/ specify yes or no"
                errorClassName="formError"
                placeholder=""
              >
                <Option key="YES" value="NO">Yes</Option>
                <Option key="NO" value="YES">No</Option>
              </PRZSelect>
            </div>
          </div>
          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                From which statuses can the
                {' '}
                {entity?.replaceAll('_', ' ')?.toLowerCase()}
                {' '}
                move to this status?
              </label>
              <PRZSelect
                onChange={(e) => setAllowedFromStatus(e)}
                value={allowedFromStatus}
                showSearch
                optionFilterProp="children"
                mode="multiple"
                maxTagCount="responsive"
                placeholder=""
              >
                {possibleFromStatuses?.filter((i) => i?.type === selectedType && i?.custom_status_id !== selectedStatus?.custom_status_id)?.map((i) => (
                  <Option key={i?.custom_status_id} value={i?.custom_status_id}>{i?.status_name}</Option>
                ))}
              </PRZSelect>
            </div>
          </div>
          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Select a status color
                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
              </label>
              <PRZSelect
                onChange={(e) => setSelectedColor(e)}
                value={selectedColor}
                showSearch
                optionFilterProp="children"
                showError={formSubmitted && !selectedColor}
                errorName="/ specify yes or no"
                errorClassName="formError"
              >
                {Object.keys(statusColors)?.map((i) => (
                  <Option key={statusColors[i]} value={statusColors[i]}>
                    <div className="custom-status-form__color">
                      <div className="custom-status-form__color-dot" style={{ backgroundColor: statusColors[i] }} />
                      <span>{i?.replaceAll('_', ' ')?.toProperCase()}</span>
                    </div>
                  </Option>
                ))}
              </PRZSelect>
            </div>
          </div>

          <div className="custom-drawer__footer">
            <div className="ant-col-md-6">
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text={!selectedStatus ? 'Add Status' : 'Update Status'}
                onClick={() => handleAddCM()}
                isLoading={createCustomStatusLoading || updateCustomStatusLoading}
                disabled={createCustomStatusLoading || updateCustomStatusLoading}
                style={{
                  width: '160px',
                  borderRadius: '5px',
                  padding: '8px 10px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>

    </div>
  );
};

const mapStateToProps = ({ UserReducers, CustomStatusReducers }) => ({
  user: UserReducers.user,
  createCustomStatusLoading: CustomStatusReducers.createCustomStatusLoading,
  updateCustomStatusLoading: CustomStatusReducers.updateCustomStatusLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createCustomStatus: (payload, callback) => dispatch(CustomStatusActions.createCustomStatus(payload, callback)),
  updateCustomStatus: (payload, callback) => dispatch(CustomStatusActions.updateCustomStatus(payload, callback)),
});

FormCustomStatus.propTypes = {
  createCustomStatusLoading: PropTypes.any,
  updateCustomStatusLoading: PropTypes.any,
  createCustomStatus: PropTypes.func,
  updateCustomStatus: PropTypes.func,
  callback: PropTypes.func,
  selectedStatus: PropTypes.any,
  possibleFromStatuses: PropTypes.any,
  entity: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FormCustomStatus));
